import {FC} from 'react';
import {CloseIcon} from 'shared/icons';
import styles from './PartnerAgreementFrame.module.css';

type Props = {
	url: string;
	title?: string;
	onClose: () => void;
};

/** Полноэкранный слой с анкетой/согласием партнёра (ссылка из `selfEmploymentProfiles[].agreement.link`). */
export const PartnerAgreementFrame: FC<Props> = ({
	url,
	title = 'Анкета Альфа-Банка',
	onClose,
}) => (
	<div className={styles.root} role="dialog" aria-modal="true" aria-label={title}>
		<header className={styles.header}>
			<h2 className={styles.title}>{title}</h2>
			<button type="button" className={styles.closeButton} aria-label="Закрыть" onClick={onClose}>
				<CloseIcon />
			</button>
		</header>

		<iframe className={styles.frame} src={url} title={title} allow="camera; clipboard-write" />
	</div>
);
